module.exports = "<xo-phone-input-a ng-if=\"!treatment\" token=\"token\" phone=\"phone\"\n                  show-phone-type=\"showPhoneType\" exclude=\"exclude\" country=\"country\"></xo-phone-input-a>\n<xo-phone-input-b ng-if=\"treatment\" phone=\"phone\" hide-phone-type=\"hidePhoneType\" show-phone-type=\"showPhoneType\"\n                  hide-work=\"hideWork\"></xo-phone-input-b>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-form-components/src/phone/phoneInput/template.html
// module id = ../node_modules/xo-form-components/src/phone/phoneInput/template.html
// module chunks = 0